import * as React from 'react';

import { SVGProps } from './type';

const SvgComponent = (props: SVGProps) => {
  const { size = 24, color, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      {...rest}
    >
      <path fill="none" d="M0 0h256v256H0z" />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
        d="M104 40H48a8 8 0 0 0-8 8v160a8 8 0 0 0 8 8h56M104 128h112M176 88l40 40-40 40"
      />
    </svg>
  );
};

export default SvgComponent;
